import React from 'react'
import Spinner from '../component/Spinner'
import * as HttpService from '../config/HttpService'
import * as API from '../constants/API'
import SimpleReactValidator from 'simple-react-validator'
import swal from '@sweetalert/with-react'
import * as Title from '../constants/PageTitle'
import { toast } from 'react-toastify'
import MaterialTable from 'material-table'
import * as Messages from '../constants/Messages'
import * as RouteLinks from '../constants/RouteLinks'
import PriceFormat from '../constants/PriceFormat'
import DateFormat from '../constants/DateFormat'
import DropdownTreeSelect from 'react-dropdown-tree-select'
// import FileUploadWithPreview from 'file-upload-with-preview'
import { FileUploadWithPreview } from 'file-upload-with-preview'
import Nestable from 'react-nestable'
import PasswordStrengthBar from 'react-password-strength-bar'
import { Modal, Button } from 'react-bootstrap'
import 'react-nestable/dist/styles/index.css'
import 'react-dropdown-tree-select/dist/styles.css'
import 'file-upload-with-preview/dist/style.css'

import ReactStars from 'react-rating-stars-component'
import xmlbuilder from 'xmlbuilder'
import fs from 'fs'
import * as Common from './Common'
import Multiselect from 'multiselect-react-dropdown'
import MultiSelect from 'react-multiple-select-dropdown-lite'
import { DateRangePickerComponent, DateTimePickerComponent } from '@syncfusion/ej2-react-calendars'
import DataTable from 'react-data-table-component'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { ReactTags } from 'react-tag-autocomplete'
import * as Permissionkeys from '../constants/PermissionKeys'
import Moment from 'moment'
import ReactSummernote from 'react-summernote'
import Accordion from 'react-bootstrap/Accordion'
import QRCode from 'qrcode'
import 'react-summernote/dist/react-summernote.css'
// import DateTimePicker from 'react-datetime-picker';
// import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css'
const getBase64 = (file, cb) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = function () {
    cb(reader.result)
  }
  reader.onerror = function (error) {
    console.log('Error: ', error)
  }
}
const ExportToExcel = (DATA, fileName) => {
  const ws = XLSX.utils.json_to_sheet(DATA)
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const data = new Blob([excelBuffer], { type: 'application/vnd.ms-excel;charset=utf-8' })
  saveAs(data, fileName + '.xlsx')
}
const toTitleCase = (str) => {
  return str.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  )
}

export {
  toTitleCase,
  React,
  ExportToExcel,
  HttpService,
  API,
  SimpleReactValidator,
  swal,
  Title,
  toast,
  MaterialTable,
  Messages,
  RouteLinks,
  PriceFormat,
  DateFormat,
  DropdownTreeSelect,
  FileUploadWithPreview,
  Nestable,
  getBase64,
  PasswordStrengthBar,
  Modal,
  Button,
  ReactStars,
  xmlbuilder,
  fs,
  Common,
  MultiSelect,
  DateRangePickerComponent,
  DataTable,
  Permissionkeys /* DateTimePicker */,
  DateTimePickerComponent,
  Spinner,
  ReactTags,
  Moment,
  ReactSummernote,
  Accordion,
  Multiselect,
  QRCode
}
